export class SnackBar {
  static readonly baseOptions = {
    duration: 3000,
    horizontalPosition: 'right' as const,
    verticalPosition: 'bottom' as const,
  };

  static readonly types = {
    success: ['snackbar-success'],
    error: ['snackbar-error'],
    warning: ['snackbar-warning'],
    info: ['snackbar-info'],
  };

  static getOptions(type: keyof typeof SnackBar.types, duration?: number) {
    return {
      ...this.baseOptions,
      duration: duration ?? this.baseOptions.duration,
      panelClass: this.types[type],
    };
  }
}
